export default __webpack_public_path__ + "static/media/notification_bot.bdd8c2ce.png";